/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesGoCampaign_Precincts.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for GoCampaign Precinct Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, October 27, 2019 - 01:52:36 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      10/27/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const GoCampaign_PrecinctList = Loadable({
    loader: () => import('../containers/GoCampaign_Precincts/GoCampaign_PrecinctListContainer'),
    loading: Loading,
});

export const GoCampaign_PrecinctForm = Loadable({
    loader: () => import('../containers/GoCampaign_Precincts/GoCampaign_PrecinctEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesGoCampaign_Precincts.js